import type { FlagRecord } from "@/hooks/useFeatureFlags/flags";

export const BACKGROUND_CHECK_STAFF_VISIBILITY_FLAG = "backoffice-background-check-staff-visibility" as const;
export const BACKGROUND_CHECK_STAFF_SEND_INVITATION_FLAG = "backoffice-background-check-staff-send-invitation" as const;
export const BACKGROUND_CHECK_STAFF_CREATE_ORDER_FLAG = "backoffice-background-check-staff-create-order" as const;
export const BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG = "backoffice-bgc-staff-disposition-edit" as const;

export function canViewBackgroundCheckStaffSection(flags: FlagRecord): boolean {
  return !!flags[BACKGROUND_CHECK_STAFF_VISIBILITY_FLAG];
}

export function canSendBackgroundCheckStaffInvitation(flags: FlagRecord): boolean {
  return canViewBackgroundCheckStaffSection(flags) && !!flags[BACKGROUND_CHECK_STAFF_SEND_INVITATION_FLAG];
}

export function canCreateBackgroundCheckStaffOrder(flags: FlagRecord): boolean {
  return canSendBackgroundCheckStaffInvitation(flags) && !!flags[BACKGROUND_CHECK_STAFF_CREATE_ORDER_FLAG];
}

export function canEditBackgroundCheckDispositionOnProspectProgram(options: {
  flags: FlagRecord;
  canManageApplications: boolean;
}): boolean {
  return (
    options.canManageApplications &&
    !!options.flags[BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG] &&
    !canViewBackgroundCheckStaffSection(options.flags)
  );
}

export function canEditBackgroundCheckRequirementOnPtm(flags: FlagRecord): boolean {
  return !!flags[BACKGROUND_CHECK_DISPOSITION_EDIT_FLAG];
}
